export default __webpack_public_path__ + "static/media/grails.75f38cbe.svg";